module.exports = __webpack_public_path__ + "static/img/11.2a544c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/18/sp/11.png
// module id = OOqU
// module chunks = 0